import z from "zod"

export const GetBigBlueOrderInfoSchema = z.object({
  orderId: z.string(),
  email: z.string().optional(),
})

export const UpsertBigBlueIntegrationSchema = z.object({
  token: z.string(),
  prefix: z.string(),
  webhooksSecretKey: z.string().optional(),
})
